import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function useLocationChange (action) {
    const location = useLocation()
    useEffect(() => { action(location) }, [location])
}
export default useLocationChange;